import { Logger } from '../../utilities/Logger'
import { allowBodyScroll, stopBodyScroll } from './controlBodyScroll'

export class ModalDialogue {
  constructor (elem) {
    this.logger = new Logger('ModalDialogue')
    this.elem = elem
    this.modalId = this.elem.dataset.modalId
    this.elem.isOpen = false
    this.setupEvents()
  }

  registerObjects () {
    this.togglers = document.querySelectorAll('[data-modal-toggle="' + this.modalId + '"]')
    this.openers = document.querySelectorAll('[data-modal-open="' + this.modalId + '"]')
    this.closers = document.querySelectorAll('[data-modal-close="' + this.modalId + '"]')
  }

  setupEvents () {
    this.registerObjects()
    this.logger.log(`Setting up events for ${this.modalId}`)

    const addClickListener = (element, handler) => {
      if (element.dataset.clickbound !== 'true') {
        element.addEventListener('click', handler)
        element.dataset.clickbound = 'true'
      }
    }

    this.elem.addEventListener('click', (e) => {
      if (e.target === this.elem && this.elem.hasAttribute('open')) {
        this.close()
      }
    })

    this.togglers.forEach((toggler) => {
      addClickListener(toggler, this.toggleHandler.bind(this))
    })

    this.openers.forEach((opener) => {
      addClickListener(opener, this.openHandler.bind(this))
    })

    this.closers.forEach((closer) => {
      addClickListener(closer, this.closeHandler.bind(this))
    })
  }

  toggleHandler (e) {
    e.preventDefault()
    this.toggle()
  }

  openHandler (e) {
    e.preventDefault()
    this.open()
  }

  closeHandler (e) {
    e.preventDefault()
    e.stopPropagation()
    this.close()
  }

  toggle () {
    if (this.elem.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open () {
    if (!this.elem.isOpen) {
      stopBodyScroll()
      this.elem.classList.add('is-open')
      this.elem.setAttribute('aria-hidden', 'false')
      this.elem.showModal()
      this.elem.isOpen = true
    }
  }

  close () {
    if (this.elem.open) {
      allowBodyScroll()
      this.elem.classList.remove('is-open')
      this.elem.setAttribute('aria-hidden', 'true')
      this.elem.close()
      this.elem.isOpen = false
    }
  }
}

export const setupModals = function (parent) {
  const elems = parent.querySelectorAll('[data-modal-id]')

  const modals = []

  for (const elem of elems) {
    modals.push(new ModalDialogue(elem))
  }

  return modals
}

window.setupModal = function (elem) {
  const modal = new ModalDialogue(elem)

  return modal
}
